import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AdministrationState } from '../reducers/base-administration.reducer';

const getAdministration = createFeatureSelector<AdministrationState>('administration');
export const getUserProfile = createSelector(getAdministration, (state) => state.userProfileData);
export const getUserPasswordUpdateStatus = createSelector(getAdministration, (state) => state.userPasswordData.ok);
export const getProfilePasswordUpdateStatus = createSelector(getAdministration, (state) => state.profilePasswordData);
export const getCustomerData = createSelector(getAdministration, (state) => state.customerData);
export const getPermissions = createSelector(getAdministration, (state) => state?.permissions);
export const getSurcharges = createSelector(getAdministration, (state) => state.surcharges);
export const getPspData = createSelector(getAdministration, (state) => state.pspData);
export const getLocationsData = createSelector(getAdministration, (state) => state.locationsData);
export const getLocations = createSelector(getAdministration, (state) => state.locations);
export const getLocationData = createSelector(getAdministration, (state) => state.location);
export const getCreatedLocationId = createSelector(getAdministration, (state) => state.createdLocationId.data);
export const getCustomerLocationTerminals = createSelector(
  getAdministration,
  (state) => state.customerLocationTerminals
);
export const getTerminalAPIKey = createSelector(getAdministration, (state) => state.terminalAPIKey);
